// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { SalesTeam } from '../_models/sales-team.model';
// Models
import { QueryParamsModel } from '../../_base/crud';

export enum SalesTeamActionTypes {
  AllSalesTeamsRequested = '[SalesTeams Module] All SalesTeams Requested',
  AllSalesTeamsLoaded = '[SalesTeams API] All SalesTeams Loaded',
  SalesTeamOnServerCreated = '[Edit SalesTeam Component] SalesTeam On Server Created',
  SalesTeamCreated = '[Edit SalesTeam Dialog] SalesTeam Created',
  SalesTeamOnServerUpdated = '[Edit SalesTeam Dialog] SalesTeam On Server Updated',
  SalesTeamUpdated = '[Edit SalesTeam Dialog] SalesTeam Updated',
  SalesTeamStatusOnServerUpdated = '[SalesTeams List Page] SalesTeam Status On Server Updated Updated',
  SalesTeamStatusUpdated = '[SalesTeams List Page] SalesTeam Status Updated Updated',
  SalesTeamsStatusOnServerUpdated = '[SalesTeams List Page] SalesTeams Status On Server Updated Updated',
  SalesTeamsStatusUpdated = '[SalesTeams List Page] SalesTeams Status Updated Updated',
  SalesTeamOnServerDeleted = '[SalesTeams List Page] SalesTeam On Server Deleted',
  SalesTeamDeleted = '[SalesTeams List Page] SalesTeam Deleted',
  ManySalesTeamsOnServerDeleted = '[SalesTeams List Page] SalesTeams On Server Deleted',
  ManySalesTeamsDeleted = '[SalesTeams List Page] SalesTeams Deleted',
  SalesTeamsPageRequested = '[SalesTeams List Page] SalesTeams Page Requested',
  SalesTeamsPageLoaded = '[SalesTeams API] SalesTeams Page Loaded',
  SalesTeamsPageCancelled = '[SalesTeams API] SalesTeams Page Cancelled',
  SalesTeamsPageToggleLoading = '[SalesTeams] SalesTeams Page Toggle Loading',
  SalesTeamsActionToggleLoading = '[SalesTeams] SalesTeams Action Toggle Loading',
  ChangePassword = '[SalesTeams] Password changed',
  ActivityPageRequested = '[SalesTeams] ActivityPageRequested',
  ThrowError = '[SalesTeams] ThrowError',
  ClearErrors = '[SalesTeams] ClearErrors',
}

export class SalesTeamOnServerCreated implements Action {
  readonly type = SalesTeamActionTypes.SalesTeamOnServerCreated;
  constructor(public payload: { request: string; salesTeam: SalesTeam }) {}
}

export class SalesTeamCreated implements Action {
  readonly type = SalesTeamActionTypes.SalesTeamCreated;
  constructor(public payload: { salesTeam: SalesTeam }) {}
}

export class ThrowError implements Action {
  readonly type = SalesTeamActionTypes.ThrowError;

  constructor(public payload: { error: any }) {}
}

export class ClearErrors implements Action {
  readonly type = SalesTeamActionTypes.ClearErrors;
}
export class SalesTeamOnServerUpdated implements Action {
  readonly type = SalesTeamActionTypes.SalesTeamOnServerUpdated;
  constructor(
    public payload: {
      partialSalesTeam: Update<SalesTeam>;
      salesTeam: SalesTeam;
    },
  ) {}
}
export class SalesTeamUpdated implements Action {
  readonly type = SalesTeamActionTypes.SalesTeamUpdated;
  constructor(
    public payload: {
      partialSalesTeam: Update<SalesTeam>;
      salesTeam: SalesTeam;
    },
  ) {}
}

export class SalesTeamStatusOnServerUpdated implements Action {
  readonly type = SalesTeamActionTypes.SalesTeamStatusOnServerUpdated;
  constructor(public payload: { id: number; is_active: boolean }) {}
}

export class SalesTeamStatusUpdated implements Action {
  readonly type = SalesTeamActionTypes.SalesTeamStatusUpdated;
  constructor(public payload: { id: number; is_active: boolean }) {}
}

export class SalesTeamsStatusOnServerUpdated implements Action {
  readonly type = SalesTeamActionTypes.SalesTeamsStatusOnServerUpdated;
  constructor(
    public payload: {
      salesTeams: SalesTeam[];
      is_active: number;
    },
  ) {}
}

export class SalesTeamsStatusUpdated implements Action {
  readonly type = SalesTeamActionTypes.SalesTeamsStatusUpdated;
  constructor(
    public payload: {
      salesTeams: SalesTeam[];
      is_active: number;
    },
  ) {}
}

export class SalesTeamOnServerDeleted implements Action {
  readonly type = SalesTeamActionTypes.SalesTeamOnServerDeleted;
  constructor(public payload: { id: number }) {}
}

export class SalesTeamDeleted implements Action {
  readonly type = SalesTeamActionTypes.SalesTeamDeleted;
  constructor(public payload: { id: number }) {}
}

export class ManySalesTeamsOnServerDeleted implements Action {
  readonly type = SalesTeamActionTypes.ManySalesTeamsOnServerDeleted;
  constructor(public payload: { ids: any[] }) {}
}

export class ManySalesTeamsDeleted implements Action {
  readonly type = SalesTeamActionTypes.ManySalesTeamsDeleted;
  constructor(public payload: { ids: any[] }) {}
}

export class SalesTeamsPageRequested implements Action {
  readonly type = SalesTeamActionTypes.SalesTeamsPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class SalesTeamsPageLoaded implements Action {
  readonly type = SalesTeamActionTypes.SalesTeamsPageLoaded;
  constructor(
    public payload: { salesTeams: SalesTeam[]; totalCount: number; page: QueryParamsModel },
  ) {}
}

export class SalesTeamsPageCancelled implements Action {
  readonly type = SalesTeamActionTypes.SalesTeamsPageCancelled;
}

export class SalesTeamsPageToggleLoading implements Action {
  readonly type = SalesTeamActionTypes.SalesTeamsPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class SalesTeamsActionToggleLoading implements Action {
  readonly type = SalesTeamActionTypes.SalesTeamsActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class ChangePassword implements Action {
  readonly type = SalesTeamActionTypes.ChangePassword;
  constructor(
    public payload: { salesTeamName: string; oldPassword: string; newPassword: string },
  ) {}
}

export type SalesTeamActions =
  | SalesTeamCreated
  | SalesTeamUpdated
  | SalesTeamDeleted
  | ManySalesTeamsDeleted
  | SalesTeamOnServerCreated
  | SalesTeamOnServerUpdated
  | SalesTeamOnServerDeleted
  | ManySalesTeamsOnServerDeleted
  | SalesTeamStatusOnServerUpdated
  | SalesTeamsStatusOnServerUpdated
  | SalesTeamsPageLoaded
  | SalesTeamsPageCancelled
  | SalesTeamsPageToggleLoading
  | SalesTeamsPageRequested
  | ChangePassword
  | SalesTeamStatusUpdated
  | SalesTeamsStatusUpdated
  | ThrowError
  | ClearErrors
  | SalesTeamsActionToggleLoading;
